export const pluralize = (count: number, singular: string, plural: string): string =>
  `${count.toLocaleString()} ${count === 1 ? singular : plural}`;
